module.exports = __webpack_public_path__ + "media/images/e-bilet/Kyiv__mobile__bg-2768ddf30e2316210c67efd020eee68d.webp";